/**
 * Program Benefits 1029 — BDU "Why Choose Bharathidasan University Online?"
 * Tinted full-bleed background art, centred heading with a rule, wrapping icon cards.
 */

export const PROGRAM_BENEFITS_1029_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Benefit cards",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_image: "",
    meta_alt_image: "",
    meta_title: "Flexible Learning",
    meta_sub_title:
      "Study independently while balancing work and life commitments.",
    meta_title_color: "#F4F217",
    meta_sub_title_color: "#FFFFFF",
    meta_priority: 1,
    meta_status: true,
  },

  PROGRAM_BENEFITS_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Heading",
      value: "Why Choose Bharathidasan University Online?",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Why Choose Bharathidasan University Online?",
    },
    {
      fieldName: "title_start_color",
      label: "Heading colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "gradient_color_1",
      label: "Rule under heading",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "image",
      label: "Background image (desktop)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      defaultValue: "",
    },
    {
      fieldName: "mobile_image",
      label: "Background image below 768px (optional — uses desktop if empty)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      defaultValue: "",
    },
    {
      fieldName: "section_overlay_rgba",
      label: "Tint over the background image (rgba)",
      value: "rgba(14, 40, 57, 0.87)",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "rgba(14, 40, 57, 0.87)",
      defaultValue: "rgba(14, 40, 57, 0.87)",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Icon",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload icon (40x40)",
      defaultValue: "",
    },
    {
      header: "Icon alt",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Description",
      fieldName: "meta_sub_title",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      defaultValue: "",
      rows: 3,
    },
    {
      header: "Title colour",
      fieldName: "meta_title_color",
      value: "#F4F217",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#F4F217",
    },
    {
      header: "Description colour",
      fieldName: "meta_sub_title_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
